/**
 * Contratação comercial de planos pagos (landing + fluxo de cadastro web).
 *
 * Plano B:
 * - Web: Pagar.me quando esta flag for `false`
 * - App nativo: nunca usa cartão/Pagar.me — veja `src/services/billingService.js`
 *
 * `true`: CTAs pagos desabilitados na home web e cadastro web ignora o gateway.
 */
export const CONTRATACAO_PLANOS_PAGOS_DESABILITADA = true;
